module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-year-2024-d78736c0195fbc3fe1f95fd0e8e874db.svg";